module.exports = __webpack_public_path__ + "static/media/logo2-transparent.b55d0293.png";